var ElementaryTypeNameExpression = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    return path.call(_print, 'typeName');
  }
};
module.exports = ElementaryTypeNameExpression;